import makeRequest from 'utils/makeRequest'
import { PUBLIC_ENDPOINTS } from 'config/apiEndpoints'
import IResponseApi from 'models/IResponseApi'
import IContact from 'models/IContact'
import IUserInfo from 'models/IUserInfo'

export const landingService = {
  sendContactMessage: async (messageBody: IContact): Promise<IResponseApi> => {
    try {
      const response: IResponseApi = await makeRequest(
        'POST',
        PUBLIC_ENDPOINTS.SendContactMessage,
        JSON.stringify(messageBody),
        'application/json'
      )

      return response
    } catch (error) {
      throw new Error('Sending Contact Message Failed')
    }
  },
  subscribe: async (userInfo: IUserInfo): Promise<IResponseApi> => {
    try {
      const response: IResponseApi = await makeRequest(
        'POST',
        PUBLIC_ENDPOINTS.Subscribe,
        JSON.stringify(userInfo),
        'application/json'
      )

      return response
    } catch (error) {
      throw new Error('Subscription Failed')
    }
  },
}
